import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useState } from 'react';

interface Props {
  content: React.ReactElement;
  isOpen: boolean;
  updateMaxHeight: (a: number) => void;
  updateOpenedHeight: (a: number) => void;
}

export const AccordionItemContent = ({ isOpen, content, updateMaxHeight, updateOpenedHeight }: Props) => {
  const accordionInner = React.useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);

  useLayoutEffect(() => {
    setWidth(window.innerWidth);

    if (accordionInner.current) {
      if (isOpen) {
        accordionInner.current.style.maxHeight = `${accordionInner.current.scrollHeight}px`;
      } else {
        accordionInner.current.style.maxHeight = '0px';
      }
    }

    function handleWindowSizeChange() {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [isOpen, width]);

  useLayoutEffect(() => {
    if (accordionInner.current) {
      const accordionInnerChild = accordionInner.current.children[0];

      if (isOpen) {
        updateOpenedHeight(accordionInnerChild.scrollHeight);
      }

      const accordionAnimationEndTime = 500;
      const timer = setTimeout(() => {
        if (accordionInnerChild && isOpen) {
          updateMaxHeight(accordionInnerChild.scrollHeight);
        }
      }, accordionAnimationEndTime);

      return () => clearTimeout(timer);
    }
  }, [width]);

  useEffect(() => {
    if (accordionInner.current) {
      if (isOpen) {
        updateMaxHeight(accordionInner.current.scrollHeight);
      }
    }
  }, [isOpen, updateMaxHeight, updateOpenedHeight, width]);

  return (
    <div ref={accordionInner} className={classNames('accordion-content', { opened: isOpen })}>
      <div>{content}</div>
    </div>
  );
};
